// extracted by mini-css-extract-plugin
export default {"informationContainer":"Info_informationContainer__zj7so","noOfTrade":"Info_noOfTrade__rJeHf","title":"Info_title__9Ap1B","value":"Info_value__TOHxH"};